export default "/images/248f978ead8f93b2230b5fc351bd3ee9.png";